<template>
  <div>
    <div class="footer">
      <div class="w900">
        <!-- 尾部导航 -->
        <div class="footer-txt">
          <dl class="fl">
            <dt>初めての方</dt>
            <dd>
              <router-link to="/login">無料会員登録</router-link>
            </dd>
            <dd>
              <router-link to="/register">新規会員登録</router-link>
            </dd>
            <dd>
              <router-link to="/course" target="_blank">利用ガイド</router-link>
              <!-- <a href="http://www.baidu.com"></a> -->
            </dd>
            <dd>
              <router-link to="/accountSynchronization" target="_blank">RAKUAMRT&1688</router-link>

            </dd>
          </dl>
          <!-- <dl class="fl">
            <dt>仕入れ会員</dt>
            <dd>
              <router-link to="/photography" target="_blank">写真撮影</router-link>
            </dd>
            <dd>
              <router-link to="/logisticsTrace" target="_blank">物流追跡</router-link>
            </dd>
            <dd>
              <router-link to="/fba" target="_blank">FBA直送サービス</router-link>
            </dd>
            <dd>
              <router-link to="/wzk" target="_blank">無在庫について</router-link>
            </dd>
          </dl> -->
          <dl class="fl">
            <dt>費用について</dt>
            <dd>
              <router-link to="/poundage" target="_blank">手数料</router-link>
            </dd>
            <dd>
              <router-link to="/freight" target="_blank">国際送料詳細</router-link>
            </dd>
            <dd>
              <router-link to="/option" target="_blank">オプション費用</router-link>
            </dd>
          </dl>
          <dl class="fl">
            <dt>会社案内</dt>
            <dd>
              <router-link to="/introduction" target="_blank">会社紹介</router-link>
            </dd>
            <dd>
              <router-link to="/guiyue" target="_blank">会員利用規約</router-link>
            </dd>
            <dd>
              <router-link to="/secret" target="_blank">プライバシーポリシー</router-link>
            </dd>
            <dd>
              <router-link to="/commonQuestion" target="_blank">よくある質問</router-link>
            </dd>
            <dd>
              <router-link to="/consult" target="_blank">問い合わせ</router-link>
            </dd>
          </dl>
        </div>
        <!-- 合作伙伴 -->
        <div class="partner">
          <img src="../../assets/img/ems.png" alt />
          <img src="../../assets/img/ocs.png" alt />
          <img src="../../assets/img/kaigen.png" alt />
          <!-- <img src="../../assets/img/logo_sgh.png" alt /> -->
          <img src="../../assets/img/zccb.png" alt />
          <img src="../../assets/img/ywg.png" alt />
          <div class="partner-txt">協力先：</div>
        </div>
        <div class="partner2">
          <img src="../../assets/img/paypal.png" alt />
          <img src="../../assets/img/netBank.webp" alt />
          <!-- <img src="../../assets/img/h_h1.png" alt /> -->
        </div>
        <p>
          <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备18023127号-2</a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
.footer {
  height: 388px;
  font-size: 16px;
  background-color: #eeeeee;

  .w900 {
    width: 900px;
    margin: 0 auto;

    .footer-txt {
      height: 195px;
      padding: 0 40px;
      border-bottom: 1px solid #ddd;

      dl {
        width: 255px;
        margin-top: 25px;

        dt {
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 16px;
          color: #333333;
        }

        dd {
          text-align: center;
          line-height: 24px;

          a {
            &:hover {
              text-decoration: underline;
              color: #999;
            }

            font-size: 12px;
            font-weight: bold;
            color: #333333;
          }
        }
      }
    }

    .partner {
      position: relative;
      margin-top: 30px;
      text-align: center;

      img {
        margin-left: 20px;
        height: 30px;
      }

      .partner-txt {
        position: absolute;
        top: 60px;
        left: 20px;
        font-size: 16px;
        font-weight: bold;
        color: #333;
      }
    }

    .partner2 {
      margin-top: 18px;
      text-align: center;

      img {
        margin-left: 20px;
        height: 30px;
      }
    }

    p {
      margin-top: 30px;
      text-align: center;
      font-size: 12px;

      a {
        color: #333;
      }
    }
  }
}
</style>